import apiClient from './apiClient';

export interface NotificationsConfig {
  isEnabled: boolean;
}

export const notificationsService = {
  getConfig: async (): Promise<NotificationsConfig> => {
    const { data } = await apiClient.get<NotificationsConfig>('/notifications/config');
    return data;
  },

  setEnabled: async (isEnabled: boolean): Promise<NotificationsConfig> => {
    const { data } = await apiClient.patch<NotificationsConfig>('/notifications/config', { isEnabled });
    return data;
  },
};
